<template>
  <div class="vx-card">
    <grid-panel
        :column-defs="columnDefs"
        height="md-plus"
        :url="() => this.$api.facilities.fdos.list(id)"
        :auto-size="true"
        @rowClicked="view"
        title="FDOs"
    >
      <vs-dropdown-item v-if="componentAccess.canCreate.access">
        <span
            class="flex items-center"
            @click="$router.push({ name: 'facilities.fdos.create' })"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>Create FDO</span>
        </span>
      </vs-dropdown-item>

    </grid-panel>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import CellRendererVerified from '@/views/components/ag-grid/cell-renderer/CellRendererVerified';
import CellRendererDate from "@/views/components/ag-grid/cell-renderer/CellRendererDate";
import CellRendererDecimal from "@/views/components/ag-grid/cell-renderer/CellRendererDecimal";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import {dateFilterParams} from '../../../components/ag-grid/filter-params/DateComparator';

export default {
  name: 'FDOList',
  components: {
    GridPanel,
    CellRendererVerified,
    CellRendererDate,
    CellRendererDecimal,
  },
  mixins: [CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canCreate: {
          route: 'facilities.fdos.create',
          access: false,
        },
      },
      columnDefs: [
        {
          headerName: 'Name',
          field: 'FDOName',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Description',
          field: 'FDODescription',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Total %',
          field: 'TotalPercentage',
          filter: 'agTextColumnFilter',
          width: 350,
          cellRenderer: "CellRendererDecimal",
        },
        {
          headerName: 'Start of effect',
          field: 'InceptionDate',
          filter: 'agDateColumnFilter',
          width: 350,
          cellRenderer: "CellRendererDate",
          filterParams: dateFilterParams,
        },
        {
          headerName: 'End of Effect',
          field: 'ExpiryDate',
          filter: 'agDateColumnFilter',
          width: 350,
          cellRenderer: "CellRendererDate",
          filterParams: dateFilterParams,
        },
        {
          headerName: 'Is Active',
          field: 'IsEnabled',
          width: 350,
          cellRenderer: 'CellRendererVerified',
          cellClass: 'text-center',
        },
        {
          headerName: 'Market',
          field: 'market.MarketDescription',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'No. of Underwriters',
          field: 'insurer_securities_count',
          filter: 'agTextColumnFilter',
          width: 350,
        },

      ]
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    async view({data}) {
      const route = 'facilities.fdos.view';

      if (await this.canAccessRoute(route)) {
        this.$router.push({ name: route, params: { id: this.id, fdoId: data.id }}).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>

</style>
